import type { MovementConfig } from '../config/movements';

const FLOW_LABELS = { leap: 'LEAP', customer: 'Customer' } as const;

export function movementFlowLabel(movement: MovementConfig): string {
  const from = FLOW_LABELS[movement.flowFrom] ?? movement.flowFrom;
  const to = FLOW_LABELS[movement.flowTo] ?? movement.flowTo;
  return `${from} → ${to}`;
}
